import axios from "axios";

export const getOrders = async (shopId, page) => {
    const options = {
        "url": `/orders?page=${page}`,
        "method": "GET",
        "headers": {
            "content-type": "application/json",
            "shop_id": shopId
        }
    }
    return await axios(options)
        .then(response => response.data)
        .catch(e => console.log(e.response.data.errors))
}

export const getDomain = () => {
    let shopDomain = null;
    const search = new URLSearchParams(window.location.search);
    if (search && search.get('shop') !== undefined) {
        shopDomain = search.get('shop')
    } else if (window.location.ancestorOrigins !== undefined) {
        shopDomain = window.location.ancestorOrigins['0'].replace("https://", "")
    }
    return shopDomain
}

export const getStore = async domain => {
    const options = {
        "url": "/app/store",
        "method": "GET",
        "headers": {
            'Content-Type': 'application/json',
            "domain": domain
        }
    }
    return await axios(options)
        .then(response => response.data)
        .catch(e => console.log(e.response.data.errors))
}

export const fulfillOrder = async (num, shopId) => {
    const options = {
        'method': 'GET',
        'url': `/orders/fulfill?order=${num}`,
        "headers": {
            "shop_id": shopId,
            'Content-Type': 'application/json',
        }
    };
    return await axios(options)
        .then(response => {
            return response.data
        })
        .catch(e => e.message)
}
export const postManual = async (num, shopId) => {
    const options = {
        'method': 'GET',
        'url': `/orders/post-manual?order=${num}`,
        "headers": {
            "shop_id": shopId,
            'Content-Type': 'application/json',
        }
    };
    return await axios(options)
        .then(response => {
            console.log("response.data", response.data)
            return response.data
        })
        .catch(e => {
            console.log("e", e);
            return e.message
        })
}

export function getOrderRange(page, perPage, total) {
    const start = (page - 1) * perPage + 1;
    const end = Math.min(page * perPage, total);
    return `${start}-${end} of ${total.toLocaleString()} orders`;
}